export const CharacterActions = {
  animal: new Set(["wolf", "goat", "cabbage"]),
  family: new Set(["mom", "dad", "boy1", "boy2"]),
};